import React, { Component } from "react";
import InputMask from 'react-input-mask'


class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valueState: this.props.value,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        valueState: this.props.value,
      });
    }
  }

  render() {
    return (
        // <div className='card-date-picker'>
        <div className=''>
            <InputMask 
            mask={this.props.mask} 
            maskChar=" " 
            required={this.props.required === false ? false : true}
            disabled={this.props.disabled}
            className="txt txt-sekunder-color"
            placeholder={this.props.placeholder || null}
            style={{backgroundColor: this.props.disabled === true && "#E6E6E6"}}
            // alwaysShowMask={true}
            value={this.props.value || this.state.valueState}
            onChange={this.props.onChange}
            />
         </div>
    // </div>
    );
  }
}

export default Pages;